export default "__VITE_PUBLIC_ASSET__38b438d3__"